<script setup lang="ts"></script>

<template>
  <div class="context-menu-separator"></div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.context-menu-separator {
  height: 1.4px;
  background: map.get(themeVariables.$colors, outlineVariant);
}
</style>
